// Điểm mở rộng của module Giao dịch & hợp đồng cho khung ứng dụng (FSD.md §2.1, §3.7): Tìm nhanh, lớp phủ ?deal=, thời gian thực.
import { qk, type RealtimeBinding } from '@/shared/api';
import { lazyComponent, fmtMoney, type OverlayDef } from '@/shared/lib';
import type { CreateItem, SearchProvider } from '@/widgets/app-shell';
import { dealStatusLabel, searchDeals } from '@/entities/deal';

/** Thành phần lớp phủ nạp khi mở (chunk riêng; OverlayHost nạp trước lúc rảnh). */
const DealOverlay = lazyComponent(() => import('./ui/overlays'), (x) => x.DealOverlay, 'DealOverlay');

/** Không có mục "Tạo mới": giao dịch sinh từ phiếu chốt căn ở bảng hàng. */
export const createItems: CreateItem[] = [];

/** Tìm nhanh: mã GD, số HĐ, mã căn (deal-service lọc theo phạm vi deals.view) ⇒ mở drawer giao dịch tại chỗ. */
export const searchProviders: SearchProvider[] = [
  {
    id: 'deals',
    module: 'deals',
    group: 'Giao dịch',
    perm: ['deals.view'],
    search: async (q, { signal }) =>
      (await searchDeals(q, signal)).map((d) => ({
        key: d.dealId,
        icon: 'file',
        title: `${d.code} · ${d.unitCode}`,
        sub: `${d.customerName} · ${dealStatusLabel(d.status)}`,
        meta: fmtMoney(d.value),
        overlay: ['deal', d.dealId] as const,
      })),
  },
];

/** ?deal=<id> — drawer giao dịch, mở từ mọi trang khi module Giao dịch hiển thị. */
export const overlays: OverlayDef[] = [{ key: 'deal', module: 'deals', layer: 'drawer', component: DealOverlay }];

/**
 * deals (gợi ý { ids }): mọi khoá 'deals' (danh sách, KPI, drawer, giao dịch trong hồ sơ khách) + Tổng quan ngay; hoa hồng và
 * doanh số là projection bất đồng bộ ⇒ binding thứ hai gộp 1,5 s rồi mới làm mới.
 */
export const realtime: RealtimeBinding[] = [
  { topic: 'deals', module: 'deals', keys: () => [qk.deals.all, qk.dashboard.all] },
  { topic: 'deals', module: 'deals', keys: () => [qk.commission.all, qk.sales.all], throttleMs: 1500 },
];
